import {createTheme} from '@mui/material/styles'
import {rxrBlackColor, rxrPrimaryColor, rxrTintColor} from './assets/styles/color.js'
import {useLocation, matchPath} from 'react-router-dom'
import Routes from './constants/RouteConstants'

const commonTheme = {
  typography: {
    fontFamily: ['inter_regular'],
  },
  palette: {},
}

const defaultTheme = {
  ...commonTheme,
  palette: {
    ...commonTheme.palette,
    primary: {
      main: rxrPrimaryColor,
    },
    secondary: {
      main: rxrTintColor,
    },
  },
  isAdmin: false,
}

const globalAdminTheme = {
  ...commonTheme,
  palette: {
    ...commonTheme.palette,
    primary: {
      main: rxrBlackColor,
    },
  },
  isAdmin: true,
}

export function useTheme() {
  const {pathname} = useLocation()
  const isGlobalAdminTheme = matchPath(pathname, {path: Routes.ADMIN_DASHBOARD})
  return createTheme(isGlobalAdminTheme ? globalAdminTheme : defaultTheme)
}
